import React from 'react';
import { useBuild } from '../../contexts/BuildContext';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'realized_pnl_usd', label: 'realized_pnl_usd' },
  { id: 'total_bought_usd', label: 'total_bought_usd' },
  { id: 'total_sold_usd', label: 'total_sold_usd' },
  { id: 'total_bought_qty', label: 'total_bought_qty' },
  { id: 'total_sold_qty', label: 'total_sold_qty' },
  { id: 'avg_cost_basis_usd', label: 'avg_cost_basis_usd' },
  { id: 'remaining_qty', label: 'remaining_qty' },
  { id: 'buy_count', label: 'buy_count' },
  { id: 'sell_count', label: 'sell_count' },
  { id: 'last_trade_time', label: 'last_trade_time' },
  { id: 'first_trade_time', label: 'first_trade_time' },
  { id: 'updated_at', label: 'updated_at' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'user_ids', label: 'Wallet / Token / Chain' },
  { id: 'date', label: 'Date Range' },
  { id: 'boolean_filters', label: 'Boolean Filters' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
  { id: 'author_in_app_users', label: 'In-App Users (your pushed wallets)' },
];

const NotificationHyperliquidPositionsQuery = () => {
  const { selectedIndex } = useBuild();
  return (
    <QueryModes
      source={selectedIndex}
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
    />
  );
};

export default NotificationHyperliquidPositionsQuery;
